import type { AreaCatalog } from '../area';
import type { common as en } from '../en/common';

export const common = {
  'common.verbatim.text': '{text}',
  'common.sentences.two': '{first} {second}',
  'common.bytes': '{value} {unit}',
  'common.asked.names': '{names} gefragt',
  'common.asked.requester': 'die Verantwortlichen gefragt',
  'common.unknown.person': 'Unbekannte Person',
  'common.unknown.group': 'Unbekannte Gruppe',
  'common.unknown.automation': 'Automatisierung',
  'common.deletedAccount': 'Gelöschtes Konto',
  'common.link.share': 'Link teilen…',
  'common.link.copy': 'Link kopieren',
  'common.error.itemNotFound': 'Aufgabe nicht gefunden.',
  'common.error.boardNotFound': 'Board nicht gefunden.',
  'common.error.groupNotFound': 'Gruppe nicht gefunden.',
  'common.error.orgMemberOnly': 'Nur Mitglieder der Organisation können {verb}.',
  'common.error.groupMemberOnly': 'Nur Mitglieder der Gruppe können für sie {verb}.',
  'common.error.accessGranted': 'Dieser Zugriff ist schon freigegeben.',
  'common.error.noAudienceGrant': 'Diese Freigabe für den Personenkreis gibt es nicht.',
  'common.error.orgNotFound': 'Organisation nicht gefunden.',
  'common.error.noOrg': 'Es gibt noch keine Organisation.',
  'common.error.relationshipNotFound': 'Beziehung nicht gefunden.',
  'common.error.itemOtherOrg': 'Die Aufgabe gehört zu einer anderen Organisation.',
  'common.error.viewNotFound': 'Board oder Ansicht nicht gefunden.',
  'common.error.orderUnchanged': 'Die Reihenfolge ist schon so.',
  'common.error.proposalNotFound': 'Vorschlag nicht gefunden.',
  'common.error.noSuchPerson': 'Diese Person gibt es nicht.',
  'common.unreachable': 'Der Server ist nicht erreichbar. Bitte versuch es noch einmal.',
  'common.error.noOrgFound': 'Keine Organisation gefunden.',
} as const satisfies AreaCatalog<typeof en>;
